import { Component, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    selector: 'ap-custom-snack-bar',
    templateUrl: './custom-snack-bar.component.html',
    styleUrls: ['./custom-snack-bar.component.css'],
    standalone: false
})
export class CustomSnackBarComponent {
  constructor(private snackBarRef: MatSnackBarRef<CustomSnackBarComponent>, @Inject(MAT_SNACK_BAR_DATA) public data: any) {

  }

  dismiss() {
    this.snackBarRef.dismiss();
  }
}
